<div class="modal-container" (click)="closeAllDropdowns()" *transloco="let t; prefix: 'workOrder'">
  <div class="modal-container__header">
    <span class="modal-container__header-title">{{ t('modals.edit.title') }}</span>
    <button class="modal-container__header-btn" (click)="closeModal()" [title]="'common.close' | transloco">
      <svg class="modal-container__header-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.1959 6.34399L11.9529 10.586L7.71087 6.34399L6.29688 7.75799L10.5389 12L6.29688 16.242L7.71087 17.656L11.9529 13.414L16.1959 17.656L17.6099 16.242L13.3679 12L17.6099 7.75799L16.1959 6.34399Z" fill="#9FA1A4"/>
      </svg>
    </button>
  </div>

  <div class="modal-container__body">
    <div class="modal-form">
      <!-- Work Order ID and Asset Row -->
      <div class="modal-form__row">
        <!-- Work Order ID (Read-only) -->
        <div class="modal-form__field modal-form__field--half">
          <label class="modal-label">{{ t('modals.shared.workOrderId') }} <span class="required">*</span></label>
          <div class="readonly-input-wrapper">
            <input class="modal-input readonly" type="text" [value]="isWorkOrderLoading ? t('modals.shared.loadingWorkOrderId') : workOrderIdString" readonly />
          </div>
        </div>

        <!-- Asset (Read-only) -->
        <div class="modal-form__field modal-form__field--half">
          <label class="modal-label">{{ t('modals.shared.asset') }} <span class="required">*</span></label>
          <div class="readonly-input-wrapper">
            <input class="modal-input readonly" type="text" [value]="isWorkOrderLoading ? t('modals.shared.loadingAsset') : selectedAssetName" readonly />
          </div>
        </div>
      </div>

      <!-- Source (Read-only) -->
      <div class="modal-form__field">
        <label class="modal-label">{{ t('modals.shared.source') }}<span class="required">*</span></label>
        <div class="readonly-input-wrapper">
          <input class="modal-input readonly" type="text" [value]="sourceDisplayText" readonly />
        </div>
      </div>

      <!-- Service Type and Technician Row -->
      <div class="modal-form__row">
        <!-- Service Type Dropdown -->
        <div class="modal-form__field modal-form__field--half" (click)="$event.stopPropagation()">
          <label class="modal-label">{{ t('modals.shared.serviceType') }} <span class="required">*</span></label>
          <div class="dropdown-input-wrapper" (click)="toggleServiceTypeDropdown()">
            <input class="modal-input" type="text" [value]="serviceTypeDisplayText" readonly />
            <svg class="dropdown-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.862 6.19534L7.99998 9.05734L5.13798 6.19534L4.19531 7.13801L7.99998 10.9427L11.8046 7.13801L10.862 6.19534Z" fill="#9FA1A4"/>
            </svg>
          </div>
          @if (serviceTypeDropdownOpen) {
            <ul class="modal-dropdown-menu">
              @for (type of serviceTypes; track type.id) {
                <li (click)="selectServiceType(type)">{{ type.name | transloco }}</li>
              }
            </ul>
          }
        </div>

        <!-- Assigned Technicians -->
        <div class="modal-form__field modal-form__field--half" (click)="$event.stopPropagation()">
          <label class="modal-label">{{ t('modals.shared.assignedTechnicians') }} <span class="required">*</span></label>
          <app-technician-multi-select-dropdown
            [technicians]="technicians"
            [selectedTechnicianIds]="formData.technicianIds"
            [isLoading]="isWorkOrderLoading || isTechniciansLoading"
            [disabled]="isWorkOrderLoading"
            (selectedTechnicianIdsChange)="onTechnicianIdsChange($event)">
          </app-technician-multi-select-dropdown>
        </div>
      </div>

      <!-- Schedule Date and Workshop Row -->
      <div class="modal-form__row">
        <!-- Schedule Date -->
        <div class="modal-form__field modal-form__field--half" (click)="$event.stopPropagation()">
          <app-flatpickr-date-picker
            [label]="t('modals.shared.scheduleDate')"
            [(value)]="scheduledDateString"
            (valueChange)="onScheduledDateChange($event)"
            [minDate]="'today'"
            [dateFormat]="'Y-m-d H:i'"
            [altFormat]="'d/m/Y H:i'"
            [placeholder]="t('modals.shared.dateTimePlaceholder')"
            [enableTime]="true"
            [required]="true">
          </app-flatpickr-date-picker>
          @if (scheduleDateTouched && scheduledDateString === '') {
            <div class="error-message">{{ t('modals.shared.scheduledDateRequired') }}</div>
          }
        </div>

        <!-- Assign Workshop -->
        <div class="modal-form__field modal-form__field--half" (click)="$event.stopPropagation()">
          <label class="modal-label">{{ t('modals.shared.assignWorkshop') }} <span class="required">*</span></label>
          <div class="dropdown-input-wrapper" (click)="toggleWorkshopDropdown()">
            <input class="modal-input" type="text" [value]="workshopDisplayText" readonly />
            <svg class="dropdown-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.862 6.19534L7.99998 9.05734L5.13798 6.19534L4.19531 7.13801L7.99998 10.9427L11.8046 7.13801L10.862 6.19534Z" fill="#9FA1A4"/>
            </svg>
          </div>
          @if (workshopDropdownOpen) {
            <ul class="modal-dropdown-menu">
              @for (workshop of workshops; track workshop.id) {
                <li (click)="selectWorkshop(workshop)">{{ workshop.name }}</li>
              }
            </ul>
          }
        </div>
      </div>

      <!-- Maintenance Reason -->
      <div class="modal-form__field">
        <label class="modal-label">{{ t('modals.shared.maintenanceReason') }}</label>
        <div class="readonly-input-wrapper">
          <input class="modal-input readonly" type="text" [value]="maintenanceReasonDisplayText" [placeholder]="t('modals.shared.maintenanceReasonPlaceholder')" readonly />
        </div>
      </div>

      <!-- Estimated Cost and Time Row -->
      <div class="modal-form__row">
        <div class="modal-form__field modal-form__field--half">
          <label class="modal-label">{{ t('modals.shared.estimatedCost') }}</label>
          <div class="input-with-prefix readonly-input-wrapper">
            <span class="input-prefix">{{ currencySymbol }}</span>
            <input class="modal-input readonly" type="number" [(ngModel)]="formData.estimatedCost" placeholder="0" readonly />
          </div>
        </div>

        <div class="modal-form__field modal-form__field--half">
          <label class="modal-label">{{ t('modals.shared.estimatedTime') }}</label>
          <div class="input-with-suffix readonly-input-wrapper">
            <input class="modal-input readonly" type="number" [(ngModel)]="formData.estimatedTime" (ngModelChange)="onTimeInputChange()" placeholder="0" readonly />
            @if (hasEstimatedTimeValue) {
              <span class="input-suffix" [style.left.px]="timeSuffixLeft">{{ t('modals.shared.hours') }}</span>
            }
          </div>
        </div>
      </div>

      <!-- Alert Notification -->
      <div class="modal-form__alert-section">
        <label class="modal-label">{{ t('modals.shared.alertNotification') }}</label>
        <div class="modal-form__alert-toggle">
          <div class="alert-toggle-content">
            <span class="alert-toggle-title">{{ t('modals.shared.enableEmailAlerts') }}</span>
            <span class="alert-toggle-description">{{ t('modals.shared.emailAlertDescription') }}</span>
          </div>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="formData.enableEmailAlerts" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="modal-actions">
        <button class="modal-btn cancel" (click)="closeModal()">{{ 'common.cancel' | transloco }}</button>
        <button class="modal-btn save" [disabled]="!isFormValid || !hasChanges || isLoading" (click)="saveWorkOrder()">
          @if (isLoading) {
            <span class="spinner-border"></span>
          } @else {
            <span>{{ t('modals.shared.saveChanges') }}</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
